/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Error_Removenda2Inputs */

const en_coinvestments_error_removenda2 = /** @type {(inputs: Coinvestments_Error_Removenda2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to remove NDA document`)
};

/**
* | output |
* | --- |
* | "Failed to remove NDA document" |
*
* @param {Coinvestments_Error_Removenda2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_error_removenda2 = /** @type {((inputs?: Coinvestments_Error_Removenda2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Error_Removenda2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_error_removenda2(inputs)
});
export { coinvestments_error_removenda2 as "coInvestments_error_removeNda" }